const BACK_TO_APP_HOME = "Back to Application Home";
const BACK_TO_BENEFITS = "Back to Benefits";
const BACK_TO_DASHBOARD = "Back to Dashboard";

const STEPS = [
  { label: "Primary business address" },
  { label: "Current coverage" },
  { label: "Results" },
];

const PRE_QUALIFY_TITLE = "Qualify for a quote";

const HI_URL = "/health-insurance-application";
const UPSELL_URL = "/health-insurance-application-mdv";

const PRIMARY_ADDRESS_UPSELL_COPY = {
  title: "Primary business address",
  description:
    "This is the main location where your company conducts the bulk of your business.",
  closeCardDescription:
    "This is the Primary Business Address we have on file for your company. If you need to update your address, go to Company > Settings and then come back to finish the application. We’ll update the changes in any existing or pending applications.",
  openCardDescription: "",
};

const PRIMARY_ADDRESS_HI_COPY = {
  title: "Primary business address",
  description:
    "This is the main location where your company conducts the bulk of your business. If you don’t have a physical office location, you can use an owner’s address.",
  closeCardDescription:
    "This is the Primary Business Address we have on file for your company. Make sure everything is accurate and Edit if you need to make any changes. We’ll update the changes in any existing or pending applications.",
  openCardDescription:
    "This is the main location where your company conducts the bulk of your business. If you don’t have a physical office location, you can use an owner’s address.",
};

const HEALTH_APP_RESULTS = {
  SUCCESS: {
    title: "Great, you can apply for a health insurance quote",
    content:
      "Now that we got that out of the way, we can jump into the application.",
    nextButtonText: "Continue",
    loadingButtonText: "Loading",
    backButtonText: "Back",
  },
  DENIED: {
    title: "Sorry, we can’t offer you a quote at this time",
    nextButtonText: "Back to dashboard",
  },
};

const BACK_BUTTON_TEXT = "Back";
const NEXT_BUTTON_TEXT = "Save & continue";
const LOADING_BUTTON_TEXT = "Loading";

const CURRENT_COVERAGE_FORM = {
  TITLE: "Current coverage",
  QUESTIONS: {
    currentlyOfferHealthInsurance:
      "Does your company currently offer health insurance?",
    currentCarrier: "What are your current health insurance providers?",
    currentCarrierOther: "Please specify",
    currentRenewalDate: "When is your renewal date?",
    cobraUsage:
      "Do you have any former employees and their dependents on your health insurance and/or COBRA?",
    cobraUsers: "How many?",
    benefitEligibleEmployees:
      "How many current employees are eligible for benefits?",
  },
  MESSAGE: {
    benefitEligibleEmployees:
      "These include both full-time and part-time employees that work 30+ hours/week.",
  },
};

export {
  BACK_TO_APP_HOME,
  STEPS,
  HEALTH_APP_RESULTS,
  PRE_QUALIFY_TITLE,
  BACK_BUTTON_TEXT,
  LOADING_BUTTON_TEXT,
  NEXT_BUTTON_TEXT,
  CURRENT_COVERAGE_FORM,
  PRIMARY_ADDRESS_HI_COPY,
  PRIMARY_ADDRESS_UPSELL_COPY,
  BACK_TO_BENEFITS,
  BACK_TO_DASHBOARD,
  UPSELL_URL,
  HI_URL,
};
